/**
 * Global Error Handler
 * Captures unhandled errors and logs them for debugging.
 * In production, errors are console-logged only (no user-facing toast).
 * Individual UI components show their own user-friendly error messages.
 */

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

let toastHandler = null;

export const setGlobalErrorHandler = (showError) => {
  toastHandler = showError;
};

/**
 * Handle unhandled promise rejections
 */
export const setupGlobalErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);

    if (!IS_PRODUCTION && toastHandler) {
      const message = event.reason?.message || 'An unexpected error occurred';
      toastHandler(message);
    }

    // Prevent default browser error handling
    event.preventDefault();
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);

    if (!IS_PRODUCTION && toastHandler && event.error) {
      const message = event.error.message || 'An unexpected error occurred';
      toastHandler(message);
    }
  });

  console.log('Global error handlers initialized');
};

/**
 * Manually report an error to the user
 */
export const reportError = (error, context = '') => {
  console.error(`Error ${context}:`, error);
  
  if (toastHandler) {
    const message = error?.message || error || 'An error occurred';
    toastHandler(message);
  }
};
